// Locales
import en from "./en.json";
import es from "./es.json";
import fr from "./fr.json";
import id from "./id.json";
import pt from "./pt.json";
import nl from "./nl.json";
import mg from "./mg.json";

const translations = {
  en: { ...en },
  es: { ...es },
  fr: { ...fr },
  id: { ...id },
  pt: { ...pt },
  nl: { ...nl },
  mg: { ...mg }
};

export default translations;
